export const colorGenerator = (index: number): string => {
  const percentageProgressColor = () => {
    if (index === 1) {
      return '#05cbce' // @primary-color
    } else if (index === 2) {
      return '#fcc227' // @warning-color
    } else if (index === 3) {
      return '#ff6259' // @error-color
    } else {
      return '#a3a9ad' // @gray-color
    }
  }
  return percentageProgressColor()
}
